var magicStyles = [":host {\n  display: contents;\n}\n.experiment-vwo {\n  display: contents;\n}"];

export default magicStyles;
